import { create } from "@mui/material/styles/createTransitions";
import api_adm from "./api";
const endpoint = "volontariat/Administrateur";

export const AdministrateurService = {
  async lister(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/liste", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async list(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/liste", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async find_one(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/find_one", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findOneById(id) {
    try {
      const result = await api_adm.get(endpoint + "/find_one", {
        params: { id_ext_user: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async remove_role(objet) {
    try {
      const result = await api_adm.post(endpoint + "/remove_role", objet);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async reset_password(objet) {
    try {
      const result = await api_adm.post(endpoint + "/reset_password", objet);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert_admin(objet) {
    try {
      const result = await api_adm.post(endpoint + "/insert_from_pgi", objet);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update_admin(objet) {
    try {
      const result = await api_adm.post(endpoint + "/insert_from_pgi", objet);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async create(data) {
   throw new Error("Method not implemented.");
  },
  async update(data) {
   throw new Error("Method not implemented.");
  },
  async softDelete(data) {
   throw new Error("Method not implemented.");
  },
  async hardDelete(data) {
   throw new Error("Method not implemented.");
  },
  async restore(data) {
   throw new Error("Method not implemented.");
  },
};
